import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, Download } from 'lucide-react';  
import { getGetBills } from "../services/allApiService";

function BillHistory() {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [bills, setBiils] = useState([]);

  const handleGoBack = () => {
    navigate("/account");
  };

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  useEffect(() => {
    const getBills = async () => {
      try {
        setLoading(true);
        const data = await getGetBills();
        if (data?.success === true) {
          setBiils(data?.data || []);
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching bills:", error);
        setLoading(false);
      }
    };
    getBills();
  }, []);

  const handleDownload = (pdfUrl) => {
    const baseUrl = process.env.REACT_APP_PDF_URL || "http://localhost/gajanand-api/public/storage";
    const fullUrl = `${baseUrl}/${pdfUrl}`;
    window.open(fullUrl, "_blank"); 
  };

  return (
    <div className="flex items-center justify-center flex-col bg-black min-h-screen p-0">
      <div className="h-screen overflow-y-scroll p-4 pb-20 flex-grow max-w-sm min-w-[375px] w-full bg-white 
            [&::-webkit-scrollbar]:w-1 
            [&::-webkit-scrollbar-track]:bg-transparent 
            [&::-webkit-scrollbar-thumb]:bg-transparent 
            scrollbar-thin scrollbar-track-transparent scrollbar-thumb-transparent">
        <p className="text-sm leading-6 mb-[15px] mt-0 tracking-wide font-lato font-semibold flex items-center">
          <span className="font-black me-1">
            <ChevronLeft size={16} onClick={handleGoBack} />
          </span>
          Bill History
        </p>
        {loading ? (
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
            <p className="text-gray-500 mt-4">Bills History...</p>
          </div>
        ) : (
          <div className="flex flex-col gap-4">
            {bills?.length > 0 ? (
              bills?.map((bill) => (
                <div
                  key={bill.bill_id}
                  className="p-3 bg-[#dde5f8] rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="flex justify-between items-center mb-2">
                    <span className="font-semibold text-gray-800">
                      {formatDateTime(bill?.previous_date)} to {formatDateTime(bill?.generation_date)}
                    </span>

                    <div className="flex items-center gap-2">
                      {bill?.bill_pdf_url && (
                        <button
                          onClick={() => handleDownload(bill.bill_pdf_url)}
                          className="p-1 rounded-full hover:bg-gray-200 transition"
                          title="Download PDF"
                        >
                          <Download size={16} className="text-blue-600" />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="flex flex-col h-full">
                <img
                  className="mb-5 max-w-full h-auto align-top"
                  src={`${process.env.PUBLIC_URL}/orderexecuted-image.svg`}
                  alt="logo"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default BillHistory;
